var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tinymce-editor',{key:_vm.tinymceKey,attrs:{"id":_vm.tinymceId,"value":_vm.content,"init":_vm.init,"width":_vm.width,"height":_vm.height,"resize":_vm.resize,"disabled":_vm.disabled},on:{"pause":_vm.handlePaste,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }